"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TeamCapacityAggregator = exports.TeamCapacityAggregatorType = void 0;
var TeamCapacityAggregatorType;
(function (TeamCapacityAggregatorType) {
    TeamCapacityAggregatorType[TeamCapacityAggregatorType["TEAM"] = 0] = "TEAM";
    TeamCapacityAggregatorType[TeamCapacityAggregatorType["MANAGER"] = 1] = "MANAGER";
    TeamCapacityAggregatorType[TeamCapacityAggregatorType["LEAD"] = 2] = "LEAD";
})(TeamCapacityAggregatorType || (exports.TeamCapacityAggregatorType = TeamCapacityAggregatorType = {}));
class TeamCapacityAggregator {
    constructor(year, month, teams) {
        this.aggregators = new Map();
        this.aggregators.set(TeamCapacityAggregatorType.TEAM, (capacity) => {
            return capacity.teamId;
        });
        this.aggregators.set(TeamCapacityAggregatorType.MANAGER, (capacity) => {
            const teamId = capacity.teamId;
            return teams[teamId]?.manager || "";
        });
        this.aggregators.set(TeamCapacityAggregatorType.LEAD, (capacity) => {
            const teamId = capacity.teamId;
            return teams[teamId]?.lead || "";
        });
    }
    get(capacity, type) {
        const fn = this.aggregators.get(type);
        return fn(capacity);
    }
}
exports.TeamCapacityAggregator = TeamCapacityAggregator;
//# sourceMappingURL=TeamCapacityAggregator.js.map